{
  "point": "积分",
  "points": "积分",
  "credits": "业绩",
  "loyaltyCredit": "忠诚度业绩",
  "statusPoints": "状态积分",
  "balancePoints": "消费积分",
  "edit": "编辑",
  "delete": "删除",
  "copyOf": "{value} 的副本",
  "numberedCopyOf": "副本 {index} / {value}",
  "total": "总计",
  "uplift": "提升",
  "approveBtn.label": "确定",
  "cancelBtn.label": "取消",
  "createBtn.label": "创建",
  "saveBtn.label": "保存",
  "searchBtn.label": "搜索",
  "updateBtn.label": "更新",
  "applyBtn.label": "应用",
  "addNewPlanBtn.label": "添加计划",
  "launchPlanBtn.label": "启动计划",
  "toOverviewBtn.label": "转到概览",
  "collapseBtn.label": "折叠",
  "extendBtn.label": "详细信息 ",
  "updateAndSave.label": "更新并保存",
  "pleaseConfirmBtn.label": "确认",
  "closeBtn.label": "关闭",
  "resetBtn.label": "重置",
  "confirmBtn.label": "确认",
  "status.inactive": "非活动",
  "status.active": "活动",
  "status.deactivated": "已取消激活",
  "status.scheduled": "已计划",
  "status.expired": "已过期",
  "status.readyToUse": "可以使用",
  "status.readyToLaunch": "准备发送",
  "status.empty": "空白",
  "status.activity.pending": "待处理",
  "status.activity.confirmed": "已确认",
  "status.activity.expired": "已过期",
  "status.activity.canceled": "已取消",
  "status.activity.removed": "已移除",
  "status.default": "缺省",
  "action.promotion": "促销",
  "action.referral": "推荐人",
  "action.action": "操作",
  "tiers.numberOfPurchases.plural.zero": "{number} 购买",
  "tiers.numberOfPurchases.plural.one": "{number} 购买",
  "tiers.numberOfPurchases.plural.two": "{number} 购买",
  "tiers.numberOfPurchases.plural.few": "{number} 购买",
  "tiers.numberOfPurchases.plural.many": "{number} 购买",
  "tiers.numberOfPurchases.plural.other": "{number} 购买",
  "validity.unlimited": "无限制",
  "validity.limitedFromEarn.value.days.plural.zero": "{number} 天",
  "validity.limitedFromEarn.value.days.plural.one": "{number} 天",
  "validity.limitedFromEarn.value.days.plural.two": "{number} 天",
  "validity.limitedFromEarn.value.days.plural.few": "{number} 天",
  "validity.limitedFromEarn.value.days.plural.many": "{number} 天",
  "validity.limitedFromEarn.value.days.plural.other": "{number} 天",
  "validity.limitedFromEarn.value.weeks.plural.zero": "{number} 周",
  "validity.limitedFromEarn.value.weeks.plural.one": "{number} 周",
  "validity.limitedFromEarn.value.weeks.plural.two": "{number} 周",
  "validity.limitedFromEarn.value.weeks.plural.few": "{number} 周",
  "validity.limitedFromEarn.value.weeks.plural.many": "{number} 周",
  "validity.limitedFromEarn.value.weeks.plural.other": "{number} 周",
  "validity.limitedFromEarn.value.months.plural.zero": "{number} 个月",
  "validity.limitedFromEarn.value.months.plural.one": "{number} 个月",
  "validity.limitedFromEarn.value.months.plural.two": "{number} 个月",
  "validity.limitedFromEarn.value.months.plural.few": "{number} 个月",
  "validity.limitedFromEarn.value.months.plural.many": "{number} 个月",
  "validity.limitedFromEarn.value.months.plural.other": "{number} 个月",
  "days": "天",
  "dayInMonth": "日",
  "month": "月",
  "months.1": "一月",
  "months.2": "二月",
  "months.3": "三月",
  "months.4": "四月",
  "months.5": "五月",
  "months.6": "六月",
  "months.7": "七月",
  "months.8": "八月",
  "months.9": "九月",
  "months.10": "十月",
  "months.11": "十一月",
  "months.12": "十二月",
  "form.missingSettingsAlert": "确保在保存并继续下一步之前输入所有必填信息。",
  "noResults.title": "未找到结果。",
  "noResults.text": "没有与您的搜索 \"{text}\" 匹配的结果。",
  "alertContainer.editModeAlert.message": "您正在编辑忠诚度计划的下一个版本。启动此新版本后，您的更改将生效。 ",
  "alertContainer.liveModeAlert.message.linkText": "了解更多",
  "alertContainer.liveModeAlert.message": "要编辑层级、固定和附加福利，请从忠诚度管理中选择更新和启动，然后切换到编辑下一个版本。{link}",
  "card.isRoadmap.text": "路线图",
  "catalogSelector.tooManyResults.title": "此搜索的结果过多。 ",
  "catalogSelector.tooManyResults.text": "请使用更具体的关键字再次尝试搜索以缩小搜索结果范围。",
  "catalogSelector.errorAlert": "发生错误，请重试。",
  "catalogSelector.searchPlaceholder.byItem": "搜索特定产品。",
  "catalogSelector.searchPlaceholder.byCatOrBrand": "选择您想要促销的特定品牌或类别。",
  "catalogSelector.checkAllItems.label": "全选",
  "catalogSelector.showAllSelections.label": "仅显示选定项目。",
  "catalogSelector.cancelBtn.label": "关闭",
  "catalogSelector.saveBtn.label": "应用并保存",
  "catalogSelector.brands.plural.zero": "{number} 个品牌",
  "catalogSelector.brands.plural.one": "{number} 个品牌",
  "catalogSelector.brands.plural.two": "{number} 个品牌",
  "catalogSelector.brands.plural.few": "{number} 个品牌",
  "catalogSelector.brands.plural.many": "{number} 个品牌",
  "catalogSelector.brands.plural.other": "{number} 个品牌",
  "catalogSelector.category.plural.zero": "{number} 个类别",
  "catalogSelector.category.plural.one": "{number} 个类别",
  "catalogSelector.category.plural.two": "{number} 个类别",
  "catalogSelector.category.plural.few": "{number} 个类别",
  "catalogSelector.category.plural.many": "{number} 个类别",
  "catalogSelector.category.plural.other": "{number} 个类别",
  "catalogSelector.product.plural.zero": "{number} 个产品",
  "catalogSelector.product.plural.one": "{number} 个产品",
  "catalogSelector.product.plural.two": "{number} 个产品",
  "catalogSelector.product.plural.few": "{number} 个产品",
  "catalogSelector.product.plural.many": "{number} 个产品",
  "catalogSelector.product.plural.other": "{number} 个产品",
  "confirmNavDialog.discardChanges.text": "请务必保存您的更改。如果您离开此页面，所有未保存的更改都将丢失。",
  "confirmNavDialog.approveBtn.label": "确定",
  "confirmNavDialog.cancelBtn.label": "取消",
  "actionDashboard.overviewLinkText.referral": "转到推荐人操作",
  "actionDashboard.editLinkText": "编辑计划",
  "dashboardOptions.launchedAt": "计划启动于： ",
  "dashboardOptions.currentlyShowingLabel": "当前显示：",
  "dashboardOptions.viewLabel": "查看：",
  "masterActions.join.largeText": "加入忠诚度",
  "masterActions.purchases.largeText": "购买",
  "status.inactive.tooltip": "设置尚未完成。",
  "status.inactive.tooltip.proomotionEnded": "此促销活动处于非活动状态，无法编辑。您可以复制促销活动或创建新促销活动。",
  "status.inactive.tooltip.connectedToRewardPools": "优惠券池 {name} 的状态为 {status}。",
  "status.inactive.tooltip.invalidPromotionRecurringDates": "检查促销日期。",
  "status.readyToUse.tooltip.promotion": "促销活动已准备就绪。您可以自动在会员的钱包中显示促销，也可以使用忠诚度令牌在营销活动编辑器中将其附加到会员。",
  "status.readyToUse.tooltip.attachable": "该操作已准备就绪，可以使用忠诚度令牌通过营销活动编辑器将其附加到联系人。",
  "status.active.tooltip.promotion": "此促销活动处于活动状态，可供您的会员使用。",
  "status.active.tooltip.attachable": "此操作处于活动状态。您无法更改设置。要编辑此操作，请先将其取消激活并等待指定的过期日期。您还可以复制操作、编辑副本，然后将副本作为新操作启动。",
  "status.active.tooltip.event": "此操作处于活动状态。您可以将操作连接到福利或自动化计划。",
  "status.deactivated.tooltip.promotion": "您已取消激活此促销，会员无法再使用。",
  "status.deactivated.tooltip.attachable": "您已取消激活此操作。要编辑或删除此操作，您必须等待指定的过期日期。您还可以复制操作、编辑副本并将副本作为新操作启动。",
  "editorTypePopup.title": "选择编辑器类型",
  "editorTypePopup.text": "没有专属访问权限的客户将看到一个冻结页面。您可以创建自定义 HTML 页面或使用我们的模板之一。",
  "editorTypePopup.options.html.text": "创建自定义 HTML 页面",
  "editorTypePopup.options.template.text": "从模板创建页面",
  "fileInputField.uploadBtn.label": "上载",
  "fileInputField.browseBtn.label": "浏览",
  "formStepsContainer.nextStep.text": "下一步",
  "formStepsContainer.prevStep.text": "上一步",
  "iconGallery.title": "忠诚度图标库",
  "iconGallery.deleteDialog.headline": "是否确定要删除此图标？",
  "iconGallery.deleteDialog.content": "删除此图标后，会员将看不到它。确保此图标未与任何操作或优惠券相关联。",
  "iconGallery.uploadResult.successMessage": "上载成功。",
  "iconGallery.searchInput.placeholder": "按名称搜索图标。",
  "iconGallery.fileUploader.tooltip": "<h3>上载</h3><b>图标上载要求：</b></br>文件：SVG 或 PNG</br>格式：方形<br>最大尺寸：200x200 像素<br>最大文件大小：100 KB</br><sub>* 我们建议使用透明背景</sub>。",
  "multiLangPopup.defaultNoticeText": "如果没有合适的语言设置，您定义的主要语言是会员看到的缺省语言。",
  "multiLangPopup.defaultTitle.currency": "货币翻译",
  "multiLangPopup.defaultTitle.language": "语言翻译",
  "multiMarketSelector.multiSelectField.placeholder": "-- 选择市场 --",
  "multiMarketSelector.selectField.placeholder": "-- 选择市场 --",
  "multiPlanSelect.label": "选择您的忠诚度计划 ",
  "preLaunchPopup.conditions.plan.title": "计划设置",
  "preLaunchPopup.conditions.plan.text": "检查您的忠诚度计划设置，确保一切设置正确并符合会员条款。",
  "preLaunchPopup.conditions.tiers.title": "层级与福利",
  "preLaunchPopup.conditions.tiers.text": "检查并确保为所有会员正确设置层级，并确保您在层级中的联系人分布与您的策略相匹配。",
  "preLaunchPopup.conditions.rewards.title": "奖励池",
  "preLaunchPopup.conditions.rewards.text": "检查并确保为所有回复上载了足够的优惠券代码，并确保所有池和优惠券的有效期定义正确。",
  "preLaunchPopup.conditions.actions.title": "操作",
  "preLaunchPopup.conditions.actions.text": "检查并确保操作涵盖想要使用的所有策略，并确保已激活所有缺省操作。",
  "preLaunchPopup.title": "是否确定要启动您的忠诚度计划？",
  "preLaunchPopup.text": "检查您的设置以确保忠诚度计划已准备好启动：",
  "timeValidityInput.radioLabel.days": "天",
  "timeValidityInput.radioLabel.weeks": "周",
  "timeValidityInput.radioLabel.months": "月",
  "ctaUrl": "CTA URL",
  "ctaText": "CTA 文本",
  "message": "消息",
  "pageNotFound": "我们似乎找不到您要查找的页面。",
  "externalEventSetup.title": "外部忠诚度事件",
  "externalEventSetup.name.label": "外部事件名称",
  "externalEventSetup.description.label": "描述",
  "externalEventSetup.description.tooltip": "描述是内部的，可帮助您管理忠诚度活动。",
  "pointsRatesFields.perDescriptor.points": "赚取条件",
  "catalog.item.type.category.name": "类别",
  "catalog.item.type.brand.name": "品牌",
  "catalog.item.type.item.name": "产品",
  "catalog.item.type.itemId.name": "项目标识",
  "exclusiveAccessOffers.options.fixedBenefit.title": "访问权限作为固定福利",
  "exclusiveAccessOffers.options.additionalBenefits.title": "访问权限作为附加福利",
  "exclusiveAccessOffers.options.action.title": "访问权限作为操作奖励",
  "exclusiveAccessOffers.options.redemption.title": "积分访问",
  "exclusiveAccessOffers.options.redemptionForFree.title": "免费访问",
  "accessValidityType.options.unlimited.name": "访问权限的有效期不受限制。",
  "accessValidityType.options.limitedFromEarn.name": "访问权限自会员获得访问权限之日起在有限的时间期间内有效。",
  "accessValidityType.options.fixedDate.name": "访问权限对所有会员在预定义的时间期间内有效。",
  "accessValidityType.options.disabled.fixedBenefit.name": "禁用访问权限可用性作为固定福利。",
  "accessValidityType.options.disabled.additionalBenefit.name": "禁用访问权限可用性作为附加福利。",
  "accessValidityType.options.disabled.reward.name": "禁用访问权限可用性作为操作奖励。",
  "createOfModify.options.create.name": "激活优惠",
  "createOfModify.options.create.tooltip": "当您激活新优惠时，活动的优惠规则将重置，并在定义的优惠时间期间内可供所有选定层级的会员使用。",
  "createOfModify.options.create.tooltip2": "当您激活新优惠时，活动的优惠限制将重置，并在定义的优惠时间期间内可供所有选定层级的会员使用。 ",
  "createOfModify.options.modify.name": "编辑活动的优惠",
  "createOfModify.options.modify.tooltip": "当您编辑活动的优惠时，您的更改不会影响已兑换此优惠的会员。",
  "exclusiveAccessFormSteps.exclusiveAccessPoolSettings.title": "排他性设置",
  "exclusiveAccessFormSteps.exclusiveAccessBlockingEditor.title": "冻结页面",
  "exclusiveAccessFormSteps.redemptionValue.title": "访问和优惠",
  "exclusiveAccessFormSteps.EXCLUSIVE_ACCESS_VALIDITY.title": "激活",
  "activityElementPointsText.loyalty": "{{points_name}}",
  "activityElementPointsText.pointsToSpend": "要消费的 {{points_name}} ",
  "activityElementPointsText.status": "状态 {{points_name}}",
  "activityElementPointsText.cashback": "现金返还",
  "activityElementPointsText.cashback.name": "{{cashback_name}}",
  "voucherTypeText.one_time": "一次性优惠券",
  "voucherTypeText.yearly": "多次使用优惠券",
  "exclusiveAccessTypeText.permanent": "永久专属访问",
  "exclusiveAccessTypeText.limitedTerm": "限时专属访问",
  "mainTabs.dashboard.title": "仪表盘",
  "mainTabs.actions.title": "操作",
  "mainTabs.rewards.title": "奖励",
  "mainTabs.tiers.title": "层级",
  "mainTabs.loyaltyWallet.title": "Loyalty Wallet",
  "mainTabs.memberProfiles.title": "会员资料",
  "mainTabs.externalEvents.title": "外部事件",
  "mainTabs.planSettings.title": "计划设置",
  "mainTabs.vouchers.title": "代金券",
  "mainTabs.exclusiveAccesss.title": "专属访问",
  "mainTabs.loyaltyManagement.title": "忠诚度管理",
  "mainTabs.security.title": "忠诚度配置",
  "actionTabs.purchases.title": "购买",
  "actionTabs.promotions.title": "促销",
  "actionTabs.engagements.title": "参与",
  "actionTabs.events.title": "事件",
  "actionTabs.referral.title": "推荐人",
  "actionTabs.join.title": "加入忠诚度",
  "tierTabs.tiers.title": "层级",
  "tierTabs.fixedBenefits.title": "固定福利",
  "tierTabs.additionalBenefits.title": "附加福利",
  "tierTabs.contactDistribution.title": "分配图",
  "managementTabs.accountSettings.title": "账户设置",
  "managementTabs.languageAndCurrency.title": "语言和货币",
  "managementTabs.planSettings.title": "计划设置",
  "managementTabs.cashbackSettings.title": "现金返还设置",
  "managementTabs.membershipSettings.title": "会员设置",
  "managementTabs.updateAndLaunch.title": "更新和启动",
  "onboardingTabs.accountSettings.title": "计划创建",
  "onboardingTabs.activation.title": "激活",
  "customerCalcPeriod.options.1.name": "过去 30 天",
  "customerCalcPeriod.options.2.name": "过去 60 天",
  "customerCalcPeriod.options.3.name": "过去 90 天",
  "customerCalcPeriod.options.6.name": "过去 6 个月",
  "customerCalcPeriod.options.12.name": "过去 12 个月",
  "planType.options.points.name": "积分和兑换",
  "planType.options.points_and_benefits.name": "积分和福利",
  "planType.options.spend.name": "消费和福利",
  "planType.options.points.tooltip": "基于积分的计划，具有一个或多个层级和积分兑换。 ",
  "planType.options.points_and_benefits.tooltip": "基于积分的计划，具有多个层级和福利，但不具有积分兑换。",
  "planType.options.spend.tooltip": "基于消费的计划，具有一个或多个层级和福利，没有积分，但具有现金返还选项规则。基于消费的计划中仅管理一种货币。如果您管理多种货币，则需要为每种货币管理单独的计划。",
  "pointsAllocatopmDelay.options.1.name": "24 小时",
  "pointsAllocatopmDelay.options.2.name": "48 小时",
  "pointsAllocatopmDelay.options.3.name": "72 小时",
  "pointsAllocatopmDelay.options.7.name": "7 天",
  "pointsAllocatopmDelay.options.14.name": "14 天",
  "pointsAllocatopmDelay.options.21.name": "21 天",
  "pointsAllocatopmDelay.options.30.name": "30 天",
  "pointsAllocatopmDelay.options.40.name": "40 天",
  "tierCalculationType.options.endOfYear.name": " 层级计算在每 [X 年] 的 12 月 31 日进行。",
  "tierCalculationType.options.endOfYear.tooltip": "层级计算在每 [x 年] 的固定日期进行。升级到更高层级的会员将在定义的期间内保持其层级状态。",
  "tierCalculationType.options.afterJoin.name": "层级计算在会员进入层级之日起 [X 个月] 内完成。",
  "tierCalculationType.options.afterJoin.tooltip": "层级计算日期可能因会员的层级进度而异。升级到更高层级的会员至少将在定义的期间内保持其层级状态。",
  "tierCalculationType.options.endOfYear.spend.tooltip": "计算层级时，忠诚度积分将被重置，但会员将保持其层级状态直到下一次计算。",
  "tierCalculationType.options.noDropout.name": "不计算层级。会员无需满足要求即可保持此层级。",
  "tierCalculationType.options.noDropout.tooltip": "仅用于升级层级才能收集积分。",
  "statusPointsExpirationType.options.tierCalc.name": "状态积分将在层级计算日期过期并重置。",
  "statusPointsExpirationType.options.tierCalc.tooltip": "积分计算完成后，积分将被重置，但会员将保持其层级状态直到下一次计算。",
  "statusPointsExpirationType.options.fromEarn.name": "层级积分会过期，自会员获得积分之日起每 [X 个月] 重置一次。",
  "statusPointsExpirationType.options.fromEarn.tooltip": "计算层级时，仅计算当天的有效积分。会员将保留其层级或降至较低层级。",
  "statusPointsExpirationType.options.never.name": "状态积分永不过期。",
  "loyaltyCreditExpirationType.options.tiersCalc.name": "忠诚度积分会在计算层级之日过期并重置。",
  "loyaltyCreditExpirationType.options.tiersCalc.tooltip": "计算忠诚度业绩时，业绩将被重置，但会员将保持其层级状态直到下一次计算。",
  "loyaltyCreditExpirationType.options.fromEarn.name": "忠诚度业绩会在会员获得业绩之日起每 [X 个月] 重置一次。",
  "loyaltyCreditExpirationType.options.fromEarn.tooltip": "计算层级时，仅计算当天的有效忠诚度积分。会员将保留其层级或降至较低层级。",
  "optIn.options.invitation.name": "诚邀所有联系人加入忠诚度计划。",
  "optIn.options.automatic.name": "所有联系人都会自动成为忠诚度会员。",
  "historicalBalancePoints.options.keep.name": "使用消费积分奖励。",
  "historicalBalancePoints.options.keep.tooltip": "此选项鼓励会员使用积分兑换奖励。",
  "historicalBalancePoints.options.remove.name": "不使用消费积分奖励。",
  "historicalBalancePoints.options.remove.tooltip": "消费积分将重置，会员必须赚取新积分才能兑换。",
  "currencyIdentifierSigh.options.symbol.name": "货币符号",
  "currencyIdentifierSigh.options.symbol.tooltip": "示例：$500",
  "currencyIdentifierSigh.options.code.name": "ISO 货币代码",
  "currencyIdentifierSigh.options.code.tooltip": "示例：500USD",
  "currencyIdentifierSigh.options.none.name": "无标识符",
  "formStepRewards.options.poolSettings.title": "池设置",
  "formStepRewards.options.uploadFile.title": "上载文件",
  "formStepRewards.options.redemptionValue.title": "优惠设置",
  "formStepRewards.options.validity.title": "有效期",
  "specialTiers.redemptopmSettings.all.name": "所有层级使用相同设置。单个层级值将被覆盖。",
  "voucherValidityType.options.unlimited.name": "优惠券的有效期不受限制。",
  "voucherValidityType.options.limitedFromEarn.name": "优惠券自会员获得优惠券之日起在有限时间期间内有效。",
  "voucherValidityType.options.fixedDate.name": "优惠券对所有会员在预定义的时间期间内有效。",
  "redemptionLimit.options.noLimit.name": "定期自动向会员显示此优惠。",
  "redemptionLimit.options.noLimit.tooltip": "如果您为层级启用切换，则兑换优惠将显示在 Loyalty Wallet 中，没有兑换限制。",
  "redemptionLimit.options.limitMember.name": "选择每个会员在此优惠的定义时间期间内可以兑换优惠券的次数。",
  "exclusiveAccessExclusivityType.options.name.fixed": "永久排他性",
  "exclusiveAccessExclusivityType.options.name.limitedTerm": "有限期排他性",
  "exclusiveAccessExclusivityType.options.name.limited": "有限排他性",
  "editorContentTextDefaultValues.tag": "专属访问",
  "editorContentTextDefaultValues.firstHeader": "<strong>提前黑色星期五</strong>",
  "editorContentTextDefaultValues.secondHeader": "<strong>销售</strong>",
  "editorContentTextDefaultValues.middleText": "我们忠实的会员可享受专属黑色星期五优惠。不要错过。立即加入忠诚度计划！",
  "editorContentTextDefaultValues.actionTopText": "还不是会员？加入我们的忠诚度计划并开始赚取奖励。",
  "editorContentTextDefaultValues.leftButton": "加入忠诚度",
  "editorContentTextDefaultValues.rightButton": "下次",
  "editorContentTextDefaultValues.actionBottomText": "<span>已经是会员？<u>登录</u></span>",
  "editorContentTextDefaultValues.middleText.mobile": "我们忠实客户的专属优惠。不要错过。立即加入我们的忠诚度计划！",
  "editorContentTextDefaultValues.actionTopText.mobile": "还不是会员？加入我们的忠诚度计划。",
  "accessUrlType.options.exactUrl.name": "冻结并提供对此页面的专属访问：",
  "accessUrlType.options.startsWithUrl.name": "冻结并提供对以此 URL 开头的所有页面的专属访问权限：",
  "formStepsContainer.tierSettings.title": "层级设置",
  "formStepsContainer.purchaseBenefits.title": "购买福利",
  "formStepsContainer.visibility.title": "可见性",
  "tierDropout.options.yes.name": "是，此层级是经过计算的，会员必须满足要求才能保持此层级。",
  "tierDropout.options.no.name": "否，此层级不存在退出场景。",
  "fixedBenfitType.options.oneTimeVoucher.name": "一次性优惠券",
  "fixedBenfitType.options.fixedYearlyVoucher.name": "固定年度优惠券（多次使用代码是必填项）。",
  "fixedBenfitType.options.eventAction.name": "事件",
  "fixedBenfitType.options.exclusiveAccess.name": "专属访问",
  "fixedBenfitType.options.custom.name": "自定义（由您独立提供）",
  "fixedBenfitType.options.fixedYearlyVoucher.additional.name": "多次使用优惠券（多次使用代码是必填项）。",
  "tierTypeOptions.regular.name": "基于积分",
  "tierTypeOptions.invite.name": "仅限邀请",
  "tierTypeOptions.invite.tooltip.learnMoreLinkText": "了解更多",
  "tierTypeOptions.invite.tooltip": "只有受邀或付费会员才能属于该层级。管理付款和会员资格。要将会员添加到此层级，使用忠诚度 API 或会员资料。 {learnMoreLink}。",
  "tierTypeOptions.spend.name": "基于消费",
  "exclusiveAccess.cardLabels.permanent": "永久",
  "exclusiveAccess.cardLabels.limtedTerm": "有限期限",
  "cards.filterBar.moreFiltersButton": "更多过滤器",
  "catalogSelector.selected.single": "已选 {items}",
  "catalogSelector.selected.multiple": "已选 {items} 和 {lastItems}",
  "iconGallery.uploadResult.failMessage": "上载期间出现错误。请确保文件符合要求。\n{showFileList,select,true{{failed} out of {total} failed: {failedDetails}} other{{failedDetails}}} ",
  "pointsRatesFields.perDescriptor.spend": "间隔",
  "activityElementMultiuplyPointsText.double": "两个",
  "activityElementMultiuplyPointsText.triple": "三个"
}
